import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { environment } from 'src/config/environments/environment';


export const profileManagementGuard: CanMatchFn = () => {
  const router:Router = inject(Router);

  if (environment.enableProfileManagement) {
    return true;
  } else {
    router.navigate(['']);
    return false;
  }
};
